import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics, isSupported, type Analytics } from 'firebase/analytics';

const measurementId = import.meta.env['VITE_FIREBASE_MEASUREMENT_ID'];

const firebaseConfig = {
  apiKey: import.meta.env['VITE_FIREBASE_API_KEY'],
  authDomain: import.meta.env['VITE_FIREBASE_AUTH_DOMAIN'],
  projectId: import.meta.env['VITE_FIREBASE_PROJECT_ID'],
  storageBucket: import.meta.env['VITE_FIREBASE_STORAGE_BUCKET'],
  messagingSenderId: import.meta.env['VITE_FIREBASE_MESSAGING_SENDER_ID'],
  appId: import.meta.env['VITE_FIREBASE_APP_ID'],
  ...(measurementId ? { measurementId } : {}),
};

const app = initializeApp(firebaseConfig);

export const firebaseAuth = getAuth(app);
export const firebaseDb = getFirestore(app);

/**
 * Firebase Analytics (GA4) instance. Resolved asynchronously because
 * isSupported() does a feature-detection (cookies, IndexedDB, etc.) that
 * can reject in some browsers and SSR contexts. The promise resolves to
 * null when no measurementId is configured (staging, local dev) or when
 * the runtime can't support analytics (e.g. bot user-agents, private mode).
 */
export const firebaseAnalytics: Promise<Analytics | null> = (async () => {
  if (!measurementId) return null;
  if (typeof window === 'undefined') return null;
  try {
    const supported = await isSupported();
    return supported ? getAnalytics(app) : null;
  } catch {
    return null;
  }
})();

export default app;
